import DeliveryTrackingSectionApp from '../Functionality/DeliveryTrackingSectionApp';
import NotInformation from '../../../../../components/NotInformation';
import CustomCard from '../../../../../components/CustomCard';
import { IconAuditTrail, IconPersonCheck, PersonDialog } from '../../../../../components/buttons/IconButtons';
import DeliveryCard from '../../SubComponents/DeliveryCard';
import DeliveryRecordModal from '../Modal/DeliveryRecordModal';
import ActivityTrackerCard from './ActivityTrackerCard';
import ClosedDeliveryCard from './ClosedDeliveryCard';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DeliveryTrackingSection = () => {
    const {
        dispatch,
        option,
        t,
        setShowModalDeliveryRecord,
        showModalDeliveryRecord,
        activityTracker,
        handleSendMessage,
        emptyFields,
        modified,
        setModified,
        handleMarkAsCompleted,
        setCommentData,
        deliveryItem,
        updatePermission
    } = DeliveryTrackingSectionApp();

    return (
        <>
            {deliveryItem?.id ? (
                <>
                    <CustomCard classCard='card-border-8px' classContent='p-0' classes='mb-2'>
                        <div className='d-flex align-items-center m-3'>
                            <IconAuditTrail className='h-24px w-24px' />
                            <p className='fs-14px font-color-general-950 ibl-font-w-600 ml-2'>{t('trail')}</p>
                        </div>

                        <div className='border-bottom-shades-300' />

                        <div className='ml-3 mb-3'>
                            <DeliveryCard
                                item={deliveryItem}
                                t={t}
                                IconComponent={PersonDialog}
                                iconClass='btn-icon-svg-24px'
                                titleKey='delivery_created_by'
                            />
                        </div>
                        {deliveryItem.closedById && (
                            <div className='ml-3'>
                                <ClosedDeliveryCard
                                    item={deliveryItem}
                                    t={t}
                                    IconComponent={IconPersonCheck}
                                    iconClass='btn-icon-svg-24px'
                                    titleKey='delivery_closed_by'
                                    dispatch={dispatch}
                                    option={option}
                                    iconCardClass='background-success-100'
                                />
                            </div>
                        )}
                    </CustomCard>

                    <ActivityTrackerCard
                        item={deliveryItem}
                        comments={activityTracker}
                        t={t}
                        handleMarkAsCompleted={handleMarkAsCompleted}
                        setCommentData={setCommentData}
                        showCompletedButton={false}
                        showCommentBox={updatePermission}
                        handleSendMessage={handleSendMessage}
                        emptyFields={emptyFields}
                        modified={modified}
                        setModified={setModified}
                    />
                </>
            ) : (
                <NotInformation
                    card={true}
                    searchElement={false}
                    showButton={true}
                    buttonTrans={t('record_delivery')}
                    buttonId='btn_create_delivery'
                    buttonOnclick={() => setShowModalDeliveryRecord(true)}
                    text={t('you_haven_not_record_any_delivery')}
                />
            )}

            {showModalDeliveryRecord && (
                <DeliveryRecordModal
                    show={showModalDeliveryRecord}
                    onHide={() => setShowModalDeliveryRecord(false)}
                />
            )}
        </>
    );
};

export default DeliveryTrackingSection;
